import { useRoles } from '@adsk/alloy-provider';

interface RoleData {
  memberGroupId?: string;
  isLoading: boolean;
  name?: string;
}

export default function useRolesData(ids: string[]): RoleData[] {
  const { data: roles, loading } = useRoles();
  let rolesData: RoleData[] = [];
  ids.forEach((id) => {
    const role = roles.find((role) => role.memberGroupId === id);
    if (!role) {
      rolesData = [...rolesData, { isLoading: loading }];
    } else {
      rolesData = [
        ...rolesData,
        {
          name: role.name,
          memberGroupId: role.memberGroupId,
          isLoading: false,
        },
      ];
    }
  });
  return rolesData;
}
